import { Validateable } from "./interfaces/validateable";

export class VerificationCode extends Validateable {
	private code: string = "";

	public getCode(): string {
		return this.code;
	}

	public get _code(): string {
		return this.code;
	}

	public set _code(s: string) {
		this.code = s;
	}
}
